up.compiler('select.selectpicker, [data-tom-select]', (element) => {
  const mode = element.dataset.tomSelectMode || 'select'

  const options = {
    plugins: [],
  }

  // Multi-select: add remove button
  if (element.multiple) {
    options.plugins.push('remove_button')
  }

  // Search: selectpicker always had search via data-live-search, Tom Select has it by default.
  // To disable search, set data-tom-select-no-search
  if (element.dataset.tomSelectNoSearch !== undefined) {
    options.controlInput = null
  }

  // Placeholder from title attribute (bootstrap-select pattern)
  if (element.title && !element.dataset.placeholder) {
    options.placeholder = element.title
  }

  // Max items for dropdown
  if (element.dataset.size) {
    options.maxOptions = parseInt(element.dataset.size)
  }

  // Tags mode
  if (mode === 'tags') {
    options.create = element.dataset.create !== 'false'
    options.plugins.push('remove_button')

    if (element.dataset.createFilter) {
      options.createFilter = new RegExp(element.dataset.createFilter)
    }

    if (element.dataset.clearButton !== undefined) {
      options.plugins.push('clear_button')
    }

    if (element.dataset.openOnFocus !== undefined) {
      options.openOnFocus = true
    }

    // Suggestions threshold
    if (element.dataset.shouldLoadThreshold) {
      const threshold = parseInt(element.dataset.shouldLoadThreshold)
      options.shouldLoad = function(query) { return query.length >= threshold }
    }

    // Warning badge for invalid items
    if (element.dataset.warningClass) {
      const regex = element.dataset.createFilter ? new RegExp(element.dataset.createFilter) : null
      options.render = options.render || {}
      options.render.item = function(data, escape) {
        const isInvalid = regex && !regex.test(data.value)
        const badgeStyle = data.badgeStyle
        const cls = (isInvalid || badgeStyle === 'danger') ? element.dataset.warningClass : ''
        return '<div class="item ' + cls + '">' + escape(data.text) + '</div>'
      }
    }
  }

  // Autocomplete mode (remote/AJAX)
  if (mode === 'autocomplete') {
    const url = element.dataset.url
    if (url) {
      options.load = function(query, callback) {
        const separator = url.includes('?') ? '&' : '?'
        fetch(url + separator + 'q=' + encodeURIComponent(query))
          .then(response => response.json())
          .then(items => callback(items))
          .catch(() => callback())
      }
      if (element.dataset.labelMethod) {
        options.labelField = element.dataset.labelMethod
      }
      if (element.dataset.valueMethod) {
        options.valueField = element.dataset.valueMethod
      }
    }
  }

  // Legacy autocomplete support: .autocomplete class with data-filter
  if (element.classList.contains('autocomplete') && element.dataset.filter) {
    const filterUrl = element.dataset.filter
    options.load = function(query, callback) {
      const url = filterUrl + '?q=' + encodeURIComponent(query)
      fetch(url)
        .then(response => response.json())
        .then(items => callback(items))
        .catch(() => callback())
    }
  }

  // Server-side search for tags (legacy data-server attribute)
  if (element.dataset.server) {
    options.load = function(query, callback) {
      fetch(element.dataset.server + '?q=' + encodeURIComponent(query))
        .then(response => response.json())
        .then(items => callback(items))
        .catch(() => callback())
    }
  }

  // HTML rendering: render option/item labels with icons
  if (element.dataset.renderHtml !== undefined) {
    let icons = element.dataset.icons ? JSON.parse(element.dataset.icons) : {}
    options.render = options.render || {}

    function renderWithIcon(data, escape) {
      let iconClass = icons[data.value]
      let iconHtml = iconClass ? '<i class="' + iconClass + ' me-2"></i>' : ''
      return '<div>' + iconHtml + escape(data.text) + '</div>'
    }

    options.render.option = renderWithIcon
    options.render.item = renderWithIcon
  }

  // A single `<select>` always reports its first option as selected, even when
  // the server chose nothing. bootstrap-select ignored that and showed its
  // `title` as a "nothing selected" placeholder — which is why every collection
  // select still carries one (`CollectionSelectInput#blank_label`). Tom Select
  // instead adopts the implicit selection, so such a field came up already
  // showing the first option: choosing that option was then a no-op that fired
  // no `change`, and anything hanging off it (`up-validate`) never ran.
  //
  // Only when the markup carries no explicit selection at all — no
  // `option[selected]` and no blank option to land on — is the value implicit.
  if (!element.multiple && options.placeholder &&
      !element.querySelector('option[selected]') &&
      !element.querySelector('option[value=""]')) {
    element.selectedIndex = -1
  }

  const ts = new window.TomSelect(element, options)
  element.tomSelect = ts

  return () => ts.destroy()
})
